import AppProvider from "./core/AppProvider";
import AppRoutes from "./routes";

const App = () => <AppProvider><AppRoutes/></AppProvider>

export default App;
